import { render, staticRenderFns } from "./LockLog.vue?vue&type=template&id=48c216b8"
import script from "./LockLog.vue?vue&type=script&lang=js"
export * from "./LockLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports